<div class="col-lg-12">
    <div class="d-flex related-title">
        {{title}}
    </div>
    @if(offers.length) {
      <div class="d-flex justify-content-center">
        <p-carousel 
            [value]="offers"
            [numVisible]="numSlides"
            [numScroll]="1"
            [circular]="true"
            [orientation]="isVertical ? 'vertical' : 'horizontal'" 
            verticalViewPortHeight="25rem"
            [responsiveOptions]="responsiveOptions"
            autoplayInterval="3000" class="w-100">
          <ng-template let-offer pTemplate="item">
            <div class="border-related m-4" [style.background-image]="'url(' +offer?.imagen?.url+')'">
                <div class="tag-info font-medium">
                    {{ offer?.descripcion }}
                </div>
             </div>
          </ng-template>
        </p-carousel>
      </div>
    } @else {
      <div>No se encontraron productos</div>
    }
</div>
